interface SessionData {
  customer_base_url: string;
  company_name: string;
  lng: string;
}

export function getSessionData(): SessionData | null {
  const session = localStorage.getItem('formoso_session');
  if (session) {
    try {
      return JSON.parse(session) as SessionData;
    } catch (e) {
      return null;
    }
  }
  return null;
}
